import { supabase } from '../supabase';

export const updateAskerAddress = async (
  addressId: number,
  addressData: {
    address: string;
    commune: string;
    city: string;
  }
) => {
  try {
    const { data, error } = await supabase
      .from('askers_addresses')
      .update({
        address: addressData.address,
        commune: addressData.commune,
        city: addressData.city,
      })
      .eq('id', addressId)
      .select()
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error updating asker address:', error);
    throw new Error('Failed to update asker address');
  }
};

export const getAskerAddress = async (addressId: number) => {
  try {
    const { data, error } = await supabase
      .from('askers_addresses')
      .select('id, address, commune, city, region')
      .eq('id', addressId)
      .single();

    if (error) throw error;
    return {
      id: data.id,
      address: data.address,
      commune: data.commune,
      city: data.city,
      region: data.region, // Add this line
    };
  } catch (error) {
    console.error('Error fetching asker address:', error);
    throw new Error('Failed to fetch asker address');
  }
};

export const getAddressInfo = async (addressId: number) => {
  if (!addressId) return '';

  try {
    const { data, error } = await supabase
      .from('askers_addresses')
      .select('address, commune')
      .eq('id', addressId)
      .single();

    if (error) throw error;
    return data ? `${data.address}, ${data.commune}` : '';
  } catch (error) {
    console.error('Error fetching address information:', error);
    return '';
  }
};

export const getFullAddressInfo = async (addressId: number) => {
  if (!addressId) return null;

  try {
    const { data, error } = await supabase
      .from('askers_addresses')
      .select('address, commune, city, region')
      .eq('id', addressId)
      .single();

    if (error) throw error;
    return data
      ? `${data.address}, ${data.commune}, ${data.city}, ${data.region}`
      : null;
  } catch (error) {
    console.error('Error fetching full address information:', error);
    return null;
  }
};

export const getAddressInfoAsker = (askersAddressId: number) => {
  return supabase
  .from('askers_addresses')
  .select('city')
  .eq('id', askersAddressId)
  .single();


}